import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const MuiFormControl = {
  styleOverrides: {
    root: ({ ownerState }) => ({
      // Ensure label has the correct size - Select needs this to be consistent with TextField label behavior
      "& .MuiInputLabel-formControl, & .MuiInputLabel-shrink": {
        ...ownerState.size === "small" && {
          fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall
        }
      }
    })
  }
};
export {
  MuiFormControl
};
//# sourceMappingURL=MuiFormControl.js.map
